<template>
  <v-row dense class="DutyActivityNoLineStart_Default pt-2 pb-1">
    <v-col cols="12" class="grey--text text--darken-1">
      {{ time(dutyActivity.fromMinutesAfterMidnight) }} - {{ time(dutyActivity.toMinutesAfterMidnight) }}
    </v-col>
  </v-row>
</template>

<script>
import dateUtils from '@/common/dateUtils';

export default {
  name: 'DutyActivityNoLineStart_Default',
  components: {},
  props: {
    dutyActivity: Object,
    themeName: String,
    dutyStopsById: Object,
    timeFormat: String,
    config: Object,
    hasTrueChildren: { type: Boolean, default: false },
  },
  computed: {
    dateString() {
      if (this.dutyActivity && this.dutyActivity.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.dutyActivity.day);
      }
      return '';
    },
  },
  methods: {
    time(minutesAfterMidnight) {
      return dateUtils.getTimeFromMinutesAfterMidnight(this.timeFormat, minutesAfterMidnight, this.dateString);
    },
  },
};
</script>
